// Respectfully copied and modified from
// https://github.com/lunametrics/youtube-google-analytics
//
// Original implementation by Bounteous

//src from https://www.simoahava.com/analytics/track-dynamically-loaded-youtube-videos-in-google-tag-manager/
export default (function (document, window, config) {
    'use strict';

    window.onYouTubeIframeAPIReady = (function () {
        let cached = window.onYouTubeIframeAPIReady;
        return function () {
            if (cached) {
                cached.apply(this, arguments);
            }

            // This script won't work on IE 6 or 7, so we bail at this point if we detect that UA
            if (!navigator.userAgent.match(/MSIE [67]\./gi)) {
                init();
            }
        };
    })();

    //*****//
    // DO NOT EDIT ANYTHING BELOW THIS LINE EXCEPT CONFIG AT THE BOTTOM
    //*****//

    // Invoked by the YouTube API when it's ready
    function init() {

        let iframes = document.getElementsByTagName('iframe');
        let embeds = document.getElementsByTagName('embed');

        digestPotentialVideos(iframes);
        digestPotentialVideos(embeds);

    }

    let tag = document.createElement('script');
    tag.src = '//www.youtube.com/iframe_api';
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    function digestPotentialVideos(potentialVideos) {

        let i;

        for (i = 0; i < potentialVideos.length; i++) {
            let isYouTubeVideo = checkIfYouTubeVideo(potentialVideos[i]);
            if (isYouTubeVideo) {
                let normalizedYouTubeIframe = normalizeYouTubeIframe(potentialVideos[i]);
                //replace the original iframe with the normalized iframe
                //changed from the source to make it work with our modal
                potentialVideos[i].parentNode.replaceChild(normalizedYouTubeIframe, potentialVideos[i]);
                addYouTubeEvents(normalizedYouTubeIframe);
            }
        }
    }

    // Determine if the element is a YouTube video or not   
    function checkIfYouTubeVideo(potentialYouTubeVideo) {
        // Exclude already decorated videos     
        if (potentialYouTubeVideo.getAttribute('data-gtm-yt')) {
            return false;
        }

        let potentialYouTubeVideoSrc = potentialYouTubeVideo.src || '';
        if (potentialYouTubeVideoSrc.indexOf('youtube.com/embed/') > -1 || potentialYouTubeVideoSrc.indexOf('youtube.com/v/') > -1) {

            return true;

        }

        return false;

    }

    // Turn embed objects into iframe objects and ensure they have the right parameters
    function normalizeYouTubeIframe(youTubeVideo) {

        let a = document.createElement('a');
        a.href = youTubeVideo.src;
        a.hostname = 'www.youtube.com';
        a.protocol = document.location.protocol;
        let tmpPathname = a.pathname.charAt(0) === '/' ? a.pathname : '/' + a.pathname;  // IE10 shim

        // For security reasons, YouTube wants an origin parameter set that matches our hostname
        let origin = window.location.protocol + '%2F%2F' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

        if (a.search.indexOf('enablejsapi') === -1) {

            a.search = (a.search.length > 0 ? a.search + '&' : '') + 'enablejsapi=1';

        }

        // Don't set if testing locally
        if (a.search.indexOf('origin') === -1 && window.location.hostname.indexOf('localhost') === -1) {
            a.search = a.search + '&origin=' + origin;
        }

        if (youTubeVideo.type === 'application/x-shockwave-flash') {
            let newIframe = document.createElement('iframe');
            newIframe.height = youTubeVideo.height;
            newIframe.width = youTubeVideo.width;
            tmpPathname = tmpPathname.replace('/v/', '/embed/');
            youTubeVideo.parentNode.parentNode.replaceChild(newIframe, youTubeVideo.parentNode);
            youTubeVideo = newIframe;
        }

        a.pathname = tmpPathname;

        if (youTubeVideo.src !== a.href + a.hash) {
            youTubeVideo.src = a.href + a.hash;
        }

        youTubeVideo.setAttribute('data-gtm-yt', 'true');

        return youTubeVideo;
    }

    // Add event handlers for events emitted by the YouTube API
    // GTM automatically tracks play, pause, and watch to end events when player API is used
    function addYouTubeEvents(youTubeIframe) {
        youTubeIframe.pauseFlag = false;
        new YT.Player(youTubeIframe, {});
    }

    return {
        init: init,
        digestPotentialVideos: digestPotentialVideos
    }

})(document, window, {
    'events': {
        'Play': true,
        'Pause': false,
        'Watch to End': true
    },
    'percentageTracking': {
        'every': 25
    }
});
/*
* Configuration Details
*
* @property events object
* Defines which events emitted by YouTube API
* will be turned into Google Analytics or GTM events
*
* @property percentageTracking object
* Object with configurations for percentage viewed events
*
*   @property each array
*   Fires an event once each percentage ahs been reached
*
*   @property every number
*   Fires an event for every n% viewed
*
* @property forceSyntax int 0, 1, or 2
* Forces script to use Classic (2) or Universal(1)
*
* @property dataLayerName string
* Tells script to use custom dataLayer name instead of default
*/